<div class="uk-text-center uk-section">
  <img src="assets/404.svg" style="width:80%;">
  <h5 class="mt-5">The page you are looking for no longer exists.</h5>
</div>
